/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */

/**
 * * `pending` - 대기 중
 * `analyzing_trends` - 트렌드 분석 중
 * `generating_ideas` - 아이디어 생성 중
 * `awaiting_approval` - 승인 대기 중
 * `creating_playlist` - 플레이리스트 생성 중
 * `generating_music` - 음악 생성 중
 * `generating_thumbnail` - 썸네일 생성 중
 * `generating_description` - 설명 생성 중
 * `completed` - 완료
 * `failed` - 실패
 * `cancelled` - 취소됨
 */
export type AgentRunStatus =
  (typeof AgentRunStatus)[keyof typeof AgentRunStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AgentRunStatus = {
  pending: "pending",
  analyzing_trends: "analyzing_trends",
  generating_ideas: "generating_ideas",
  awaiting_approval: "awaiting_approval",
  creating_playlist: "creating_playlist",
  generating_music: "generating_music",
  generating_thumbnail: "generating_thumbnail",
  generating_description: "generating_description",
  completed: "completed",
  failed: "failed",
  cancelled: "cancelled",
} as const;
